import React from 'react';
import { SectionHeader } from '../../../partner-pages/utils/section-header';

const NoticeChanceSection = () => {
  return (
    <div className="bg-grey-140">
      <div className="wg-container pt-28 pb-64 lg:pb-52">
        <SectionHeader
          heading={'Chances of getting a notice'}
          align="center"
          description="Are you worried about getting a notice?"
          className="font-semibold text-s-46"
        />
        <div className="flex gap-6">
          <div className="bg-white rounded-xl shadow-sm ">
            <img
              src="https://assets.clear.in/cleartax/images/1757585785_group1814224546.svg"
              alt="filing_with_cleartax"
              className="pt-3 px-3"
            />
            <div className="py-12 text-center font-semibold text-s-32 leading-none lg:text-s-28">
              3.2% of ITR filers receive <br /> ITR notice
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm ">
            <img
              src="https://assets.clear.in/cleartax/images/1757585801_group1814224548.svg"
              alt="filing_with_cleartax"
              className="pt-3 px-3"
            />
            <div className="pt-12 text-center font-semibold text-s-32 leading-none">
              With ClearTax we guarantee <br />{' '}
              <span className="text-blue-600">no notice stress </span>
            </div>
            <div className="text-base text-center pt-1 pb-8">
              And any notice is fully managed for free.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeChanceSection;
